import { render, staticRenderFns } from "./SidebarServico.vue?vue&type=template&id=b2981220"
import script from "./SidebarServico.vue?vue&type=script&lang=js"
export * from "./SidebarServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports